
import { motion } from 'framer-motion';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import GalleryHero from './components/GalleryHero';
import GalleryGrid from './components/GalleryGrid';

const GalleryPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <motion.main
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
      >
        <GalleryHero />
        <GalleryGrid />
      </motion.main>

      <Footer />
    </div>
  );
};

export default GalleryPage;
